module.exports = __webpack_public_path__ + "static/media/feature.4e9199af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Picton/feature.jpg
// module id = 308
// module chunks = 0